import { useEffect, useState } from "react";
import { CollectionSheetForm } from "../fragments.accounting/CollectionSheetForm";
import { CollectionSheetList } from "../fragments.accounting/CollectionSheetList";
import { getCurrentDate } from "../../../configs/helpers";
import {
    fetchedAllGangs,
    fetchedAllSellers,
    fetchedSalesBySeller,
} from "../../../apis/apis.accounting/apisCash";
import { toast } from "react-toastify";

const initialQuestionState = {
    userID: "0",
    gangID: "0",
    searchDate: getCurrentDate("-"),
    selectedGangs: [],
};
const initialCashFlowState = {
    transactionDate: getCurrentDate("-"),
    description: "",
    type: "E",
    operationID: 0,
    total: 0,
    userID: 0,
};

export function CollectionSheetPage() {
    const [questionState, setQuestionState] = useState(initialQuestionState);
    const [gangs, setGangs] = useState([]);
    const [sellers, setSellers] = useState([]);
    const [sales, setSales] = useState([]);
    const [cashFlow, setCashFlow] = useState(initialCashFlowState);
    const [cashFlowSet, setCashFlowSet] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    function handleChange(e) {
        setQuestionState({ ...questionState, [e.target.name]: e.target.value });
    }

    const handleCheckboxChange = (gangID) => {
        setQuestionState({
            ...questionState,
            selectedGangs: questionState.selectedGangs.includes(gangID)
                ? questionState.selectedGangs.filter((id) => id !== gangID)
                : [...questionState.selectedGangs, gangID],
        });
    };

    const getAllGangs = async () => {
        try {
            const response = await fetchedAllGangs();
            setGangs(response);
        } catch (error) { throw error; }
    };

    const getAllSellers = async () => {
        try {
            const response = await fetchedAllSellers();
            setSellers(response.filter((s) => s.isActive));
        } catch (error) { throw error; }
    };

    const getAllSalesBySeller = async () => {
        if (questionState.userID === "0") {
            toast.warning("Seleccione un vendedor");
            return;
        }
        try {
            const response = await fetchedSalesBySeller(questionState);
            if (response.length) {
                setSales(response);
            } else {
                toast.warning("No hay registros.");
                setSales([]);
            }
        } catch (error) { throw error; }
    };

    useEffect(() => {
        getAllGangs();
        getAllSellers();
    }, []);

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
    const labelClass =
        "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Hoja de cobranza
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">Finanzas</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">
                                    Hoja de cobranza
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Main content */}
            <section>
                <div className="max-w-full px-4 space-y-4">

                    {/* Filter panel */}
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
                        <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                            <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                                <i className="fas fa-filter text-blue-500"></i>
                                Filtros de búsqueda
                            </h2>
                        </div>
                        <div className="px-5 py-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 items-end">

                                {/* Fecha */}
                                <div className="lg:col-span-2">
                                    <label htmlFor="searchDate1" className={labelClass}>Fecha</label>
                                    <input
                                        type="date"
                                        id="searchDate1"
                                        name="searchDate"
                                        value={questionState.searchDate}
                                        onChange={handleChange}
                                        className={inputClass}
                                    />
                                </div>

                                {/* Vendedor */}
                                <div className="lg:col-span-3">
                                    <label htmlFor="userID1" className={labelClass}>Vendedor</label>
                                    <select
                                        id="userID1"
                                        name="userID"
                                        value={questionState.userID}
                                        onChange={handleChange}
                                        className={inputClass}
                                    >
                                        <option value="0" disabled>Elegir...</option>
                                        {sellers?.map((g, i) => (
                                            <option key={i} value={g.sellerID}>{g.sellerName}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Grupos */}
                                <div className="lg:col-span-5">
                                    <p className={labelClass}>Grupos / Rutas</p>
                                    <div className="flex flex-wrap gap-2">
                                        {gangs.map((gang) => (
                                            <label
                                                key={gang.gangID}
                                                className={`inline-flex items-center gap-1.5 cursor-pointer rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors ${
                                                    questionState.selectedGangs.includes(gang.gangID)
                                                        ? "border-blue-500 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                                                        : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:border-blue-400"
                                                }`}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="sr-only"
                                                    id={`gang${gang.gangID}`}
                                                    value={gang.gangID}
                                                    checked={questionState.selectedGangs.includes(gang.gangID)}
                                                    onChange={() => handleCheckboxChange(gang.gangID)}
                                                />
                                                {gang.gangName}
                                            </label>
                                        ))}
                                    </div>
                                    <p className="mt-1.5 text-xs text-gray-400 dark:text-gray-500">
                                        {questionState.selectedGangs.length > 0
                                            ? `${questionState.selectedGangs.length} grupo(s) seleccionado(s)`
                                            : "Ninguno seleccionado"}
                                    </p>
                                </div>

                                {/* Filtrar */}
                                <div className="lg:col-span-2">
                                    <button
                                        onClick={getAllSalesBySeller}
                                        className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                                    >
                                        <i className="fas fa-search"></i>
                                        Filtrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* List */}
                    <CollectionSheetList
                        sales={sales}
                        setCashFlow={setCashFlow}
                        setCashFlowSet={setCashFlowSet}
                        setIsModalOpen={setIsModalOpen}
                    />
                </div>
            </section>

            {/* Modal */}
            <CollectionSheetForm
                setCashFlow={setCashFlow}
                cashFlow={cashFlow}
                cashFlowSet={cashFlowSet}
                setCashFlowSet={setCashFlowSet}
                getAllSalesBySeller={getAllSalesBySeller}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
            />
        </>
    );
}
